<template>
    <component :is="layout" :version="version" :title="title">
        <router-view v-slot="{Component}" >
            <transition :name="transitionName">
                <component :is="Component" />
            </transition>
        </router-view>
    </component>
</template>

<script> 


import layout from '@/components/UI/Full.vue';
export default {
    data(){
        return{
            transitionName: null,
            hiJackNextNav: false,
            authBootstrapPromise: null,
        }
    },
    computed:{
        layout(){
            return layout;
        },
        title(){
            let hasPageName = this.$route.meta && this.$route.meta.pageName;
            return hasPageName ? this.$route.meta.pageName : this.$route.name || this.$store.state.appStatus
        },
        version(){
            return this.$route.meta.layout;
        },
        authUser() {
            return this.$auth0.user?.value ?? this.$auth0.user;
        },
        authIsAuthenticated() {
            return this.$auth0.isAuthenticated?.value ?? this.$auth0.isAuthenticated;
        },
        authIsLoading() {
            return this.$auth0.isLoading?.value ?? this.$auth0.isLoading;
        },
    },
    watch: {
        $route (to, from) {
            if (from.path === '/cart'){
                this.transitionName = 'slide-right';
                return;
            }
            this.transitionName = to.path == '/' ? 'slide-right' : 'slide-left';
        },
    },
    methods: {
        updateTitle(txt){
            this.title = txt;
        },
        async waitForAuthReady(timeoutMs = 12000) {
            if (!this.authIsLoading) return true;
            const start = Date.now();
            while (this.authIsLoading && Date.now() - start < timeoutMs) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            return !this.authIsLoading;
        },
        async getToken(){
            if (!this.authIsAuthenticated) {
                // if not authed after loading is compelete, login redirect
                localStorage.setItem('lastPath', window.location.pathname);
                this.$auth0.loginWithRedirect({ redirect_uri: window.location.origin, skipRedirectCallback: true });
                return false;
            }
            console.log(this.authIsAuthenticated + ':  already authed');
            let token = await this.$auth0.getAccessTokenSilently();
            this.$store.dispatch('initData', { user: this.authUser, token });
            this.$axios.init();
            return true;
        },
        async ensureAuthInitialized() {
            if (this.$store.state.hasToken) return true;
            if (this.authBootstrapPromise) return this.authBootstrapPromise;
            this.authBootstrapPromise = (async () => {
                const authReady = await this.waitForAuthReady();
                if (!authReady) {
                    // Avoid indefinite "looking up account..." spinner when Auth0 state stalls.
                    localStorage.setItem('lastPath', window.location.pathname);
                    await this.$auth0.loginWithRedirect({ redirect_uri: window.location.origin, skipRedirectCallback: true });
                    return false;
                }
                return this.getToken();
            })();
            try {
                return await this.authBootstrapPromise;
            } finally {
                this.authBootstrapPromise = null;
            }
        },
        async checkRoute(to, from) {
            console.log(to.path, from.path, window.location.href);
            if(this.hiJackNextNav){
                let lp = localStorage.getItem('lastPath') || to.path;
                localStorage.removeItem('lastPath');
                this.hiJackNextNav = false;
                return lp;
            }
            if(to.query.hasOwnProperty('code')){
                this.hiJackNextNav = true;
                return false;
            }
            if(!to.meta.authRequired) { return true; } // auth not required
            if(!!this.$store.state.hasToken) {
                this.$axios.init();
                return true;
            } // protect route nav
            return await this.ensureAuthInitialized();
        }
    },
    created(){
        this.$router.beforeEach(this.checkRoute);

    },
    mounted(){
        const height = window.innerHeight;
        document.documentElement.style.setProperty("--vp-height", window.innerHeight + 'px');
        window.addEventListener('resize', ()=>{
            window.scrollTo(0,0);
            document.documentElement.style.setProperty("--vp-height", window.innerHeight + 'px');    
        });
    }
}
</script>
